import styled from "styled-components";

import {
  ClassworkDropdownContainer,
  ClassworkDropdownContent,
} from "pages/[tenant]/g/components/molecules/ClassworkDropdown/styles";

export const GroupSidebarTopicsContainer = styled.div`
  background-color: ${({ theme }) =>
    theme.classwork.imersive.bluredBackgroundColor};
  backdrop-filter: blur(10px);

  margin-top: 0.75rem;

  border: 1px solid
    ${({ theme }) => theme.classwork.imersive.dropdownBorderColor};

  border-radius: 4px;

  > .loading-skeleton {
    list-style: none;

    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: space-between;

    padding: 1.375rem 1rem;

    height: 64px;
  }

  :not(:has(${ClassworkDropdownContainer})) {
    border: none;
  }

  > .loader {
    padding: 1rem 0;
    border-top: 1px solid
      ${({ theme }) => theme.classwork.imersive.dropdownBorderColor};
  }

  ${ClassworkDropdownContainer}[data-active="false"] {
    .infinity-scroll {
      display: none;
    }
  }

  ${ClassworkDropdownContainer}[data-active="true"] {
    ${ClassworkDropdownContent} {
      max-height: 400px;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 4px;
        display: block;
      }

      &::-webkit-scrollbar-track {
        width: 4px;
        display: block;
      }

      &::-webkit-scrollbar-thumb {
        width: 4px;
        display: block;
      }
      &:has(.infinity-scroll) {
        padding-bottom: 3rem;
      }
    }
  }
`;
